module.exports = "/_next/static/images/4b8269b609e1705decd6999cf767b208-logo-nu-xs.png";